module.exports = __webpack_public_path__ + "static/media/BOU-NEW.dd2e4c7b.apng";